import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CadensSharedModule} from '../../shared';
import {
    CommissionService,
    CommissionPopupService,
    CommissionDialogComponent,
    CommissionPopupComponent,
    commissionRoute,
    commissionPopupRoute
} from './';
import {CalendarModule, InputTextModule, DataTableModule, SharedModule} from 'primeng/primeng';
import {CadensBlocksModule} from '../blocks/blocks.module';

let ENTITY_STATES = [
    ...commissionRoute,
    ...commissionPopupRoute,
];

@NgModule({
    imports: [
        CadensSharedModule,
        CadensBlocksModule,
        InputTextModule,
        CalendarModule,
        DataTableModule, SharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        CommissionDialogComponent,
        CommissionPopupComponent,
    ],
    entryComponents: [
        CommissionDialogComponent,
        CommissionPopupComponent,
    ],
    providers: [
        CommissionService,
        CommissionPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensCommissionModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/commission/commission.module.ts